interface PlaceholderWidgetProps {
  name: string;
  icon: string;
}

export default function PlaceholderWidget({ name, icon }: PlaceholderWidgetProps) {
  return (
    <div className="widget-card widget-placeholder">
      <div className="widget-header">
        <h3>{icon} {name}</h3>
      </div>
      <p className="coming-soon">Coming Soon</p>
    </div>
  );
}
